import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './actionButton.scss'

const ActionButton = (props) => {
  const { children, disabled, onClick } = props

  const actionButtonClass = classNames(styles.actionButton, {
    [styles.disabled]: disabled
  })

  const actionButtonStyle = {}

  return (
    <button
      className={actionButtonClass}
      style={actionButtonStyle}
      type="button"
      onClick={!disabled ? onClick : null}
    >
      {children}
    </button>
  )
}

ActionButton.defaultProps = {
  children: null,
  disabled: false,
  onClick: null,
  action: null
}

ActionButton.propTypes = {
  action: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
    url: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

export default ActionButton
